<template>
  <!-- <el-container class="index-con">
    <el-header class="index-header">
      <navcon></navcon>
    </el-header>
    <el-container class="index-con">
      <el-aside :class="showclass">
        <leftnav></leftnav>
      </el-aside>
      <el-container class="main-con">
        <el-main clss="index-main">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-container>
  </el-container> -->

  <el-container class="index-con">
    <el-aside :class="showclass">
      <leftnav></leftnav>
    </el-aside>
    <el-container class="main-con">
      <el-header class="index-header">
        <navcon></navcon>
      </el-header>
      <el-main class="index-main">
      <!--  <div class="zdindx"  @click="handleZd">
          <img src="../assets/img/zds.png" />
            <div class="animate wave">
                <div class="w1"></div>
                <div class="w2"></div>
                <div class="w3"></div>
                <div class="w4"></div>
            </div>
        </div> -->
        <transition name="fade-transform" mode="out-in">

						<router-view></router-view>

        </transition>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
// 导入组件
import navcon from '../components/navcon.vue'
import leftnav from '../components/leftnav.vue'
export default {
  name: 'index',
  data() {
    return {
      showclass: 'asideshow',
      showtype: false
    }
    isZdTime:false
  },
  // 注册组件
  components: {
    navcon,
    leftnav
  },
  methods: {

    handleZd(){
      // window.location.href="http://192.168.255.237:8080/estateManage/api/yearBill/findDepartmentYearBill?departmentId=31&year=2020"
      let pid = JSON.parse(sessionStorage.getItem('userdata')).departmentId
      window.open('https://zf.myhaomei.com/estateManage/api/yearBill/findDepartmentYearBill?departmentId='+pid+'&year=2020','_blank')
    },



    nowInDateBetwen (d1,d2) {
        //如果时间格式是正确的，那下面这一步转化时间格式就可以不用了
         // var dateBegin = new Date(d1.replace(/-/g, "/"));//将-转化为/，使用new Date
           // var dateEnd = new Date(d2.replace(/-/g, "/"));//将-转化为/，使用new Date
        var dateBegin = new Date(d1);//将-转化为/，使用new Date
        var dateEnd = new Date(d2);//将-转化为/，使用new Date
        var dateNow = new Date();//获取当前时间

        var beginDiff = dateNow.getTime() - dateBegin.getTime();//时间差的毫秒数
        var beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000));//计算出相差天数

        var endDiff = dateEnd.getTime() - dateNow.getTime();//时间差的毫秒数
        var endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000));//计算出相差天数
        if (endDayDiff < 0) {//已过期
            console.log('已过期');
            this.isZdTime = false
            return
        }
        if (beginDayDiff < 0) {//没到开始时间
            console.log("没到开始时间");
            this.isZdTime = false
            return
        }
        this.isZdTime = true
        console.log('在时间范围内');
    }
  },
  created() {
    // 监听
    this.$root.Bus.$on('toggle', value => {
      if (value) {
        this.showclass = 'asideshow'
      } else {
        setTimeout(() => {
          this.showclass = 'aside'
        }, 300)
      }
    })

    this.nowInDateBetwen('2021-01-01','2021-01-10')


  },
  beforeUpdate() {},
  // 挂载前状态(里面是操作)
  beforeMount() {

  }
}
</script>
<style >
  .zdindx{
    width: 140px;
    height: 140px;
    position: fixed;
    cursor: pointer;
    z-index: 99;
    top:65px ;
    right: 0;
    transition: all 0.5s;
    transform: translateX(69px);
  }
  .zdindx:hover{
    transform: translateX(0);
  }
  .zdindx img{
    width: 140px;
  }
 .el-dialog__header{
   background: #79bbff;
   padding: 16px 20px 10px
 }
 .el-dialog__title{
   color: #fff;
 }
 .el-dialog__headerbtn .el-dialog__close{
   color: #fff;
 }

.index-con {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
}

.aside {
  width: 64px !important;
  height: 100%;
  background-color: #FFFFFF;
  margin: 0px;
}
.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #FFFFFF;

  margin: 0px;
	box-sizing: border-box;
}
.index-header,
.index-main {
  padding: 0px;
	position: relative;
	overflow-x: hidden;
	background: #659be0;
}
.index-main {
	background: #FFFFFF;
	border-left: 4px solid #ebebeb;
	padding: 10px;
}
.zdindx img{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
}
@-webkit-keyframes opac{
        from {
            opacity: 1;
            width:0;
            height:0;
            top:50%;
            left:50%;
        }
        to {
            opacity : 0;
            width:100%;
            height:100%;
            top:0;
            left:0;
        }
    }
    .animate .w2{
        /*延迟1s*/
        -webkit-animation-delay:1s;
    }
    .animate .w3{
        -webkit-animation-delay:2s;
    }
    .animate .w4{
        -webkit-animation-delay:3s;
    }
    .wave{
        width: 140px;
        height: 140px;
        position: absolute;
        border: 1px #00FF00;
        z-index: 1;
        top: -32px;
        right: 32px;
    }
    .wave div{
        border:1px solid #507ff0;
        position:absolute;
        border-radius:50%;
        animation:opac 4s infinite;
    }

</style>



// WEBPACK FOOTER //
// src/views/index.vue